import request from '@/http/request'

export const getEpcCycle = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/epcCycleReport/query`, params, {
    noSpin: true
  })
}
